export default __webpack_public_path__ + "static/artifakt-legend-light-d4c46ad10e7d1cb2c2dfe6db0f11ea64.svg";